import React from "react";

interface CustomLoaderProps {
  /** Kept for existing callers. The loader is visible while this component is mounted. */
  apiResponse?: boolean;
}

/**
 * Page loader. Parents mount it only while a request is in flight and
 * unmount it when data is ready, so it cannot stay on after the response.
 */
const CustomLoader: React.FC<CustomLoaderProps> = () => {
  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[9999]">
      <div className="h-1 w-full overflow-hidden bg-[#F3E8EC]">
        <div className="h-full w-1/3 animate-[yhprogress_1s_ease-in-out_infinite] bg-[#841C39]" />
      </div>
      <div className="pointer-events-none absolute left-1/2 top-16 -translate-x-1/2">
        <div className="flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-[#841C39] shadow-md">
          <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-[#E8D0D8] border-t-[#841C39]" />
          Loading
        </div>
      </div>
      <style>{`
        @keyframes yhprogress {
          0% { transform: translateX(-120%); }
          100% { transform: translateX(360%); }
        }
      `}</style>
    </div>
  );
};

export default CustomLoader;
